import Phaser from "phaser";
import { CRIT_TINT_GOLD } from "@/game/ui/floating-combat-text";

const BANNER_DEPTH = 50_001;
const PARTICLE_DEPTH = 50_000;

export function playLevelUpEffect(
  scene: Phaser.Scene,
  worldX: number,
  worldY: number,
  newLevel: number,
): void {
  const anchorY = worldY - 8;
  const banner = scene.add
    .text(worldX, anchorY - 52, "เลเวลอัพ!", {
      fontFamily: "system-ui, sans-serif",
      fontSize: "26px",
      fontStyle: "bold",
      color: "#ffe566",
      stroke: "#b8860b",
      strokeThickness: 5,
    })
    .setOrigin(0.5, 1)
    .setDepth(BANNER_DEPTH)
    .setScale(0.4)
    .setAlpha(0);

  const levelLine = scene.add
    .text(worldX, anchorY - 22, `Lv.${newLevel}`, {
      fontFamily: "system-ui, sans-serif",
      fontSize: "20px",
      fontStyle: "bold",
      color: "#fff8dc",
      stroke: "#92400e",
      strokeThickness: 4,
    })
    .setOrigin(0.5, 1)
    .setDepth(BANNER_DEPTH)
    .setScale(0.5)
    .setAlpha(0);

  scene.tweens.add({
    targets: [banner, levelLine],
    alpha: 1,
    scale: 1,
    duration: 220,
    ease: "Back.easeOut",
  });

  scene.tweens.add({
    targets: [banner, levelLine],
    y: "-=44",
    alpha: 0,
    delay: 520,
    duration: 900,
    ease: "Cubic.easeIn",
    onComplete: () => {
      banner.destroy();
      levelLine.destroy();
    },
  });

  const burstCount = 14;
  for (let i = 0; i < burstCount; i++) {
    const angle = (i / burstCount) * Math.PI * 2 + Phaser.Math.FloatBetween(-0.15, 0.15);
    const dist = Phaser.Math.Between(36, 64);
    const size = Phaser.Math.Between(2, 5);
    const dot = scene.add
      .circle(worldX, anchorY - 36, size, CRIT_TINT_GOLD)
      .setDepth(PARTICLE_DEPTH)
      .setAlpha(0.95);
    scene.tweens.add({
      targets: dot,
      x: worldX + Math.cos(angle) * dist,
      y: anchorY - 36 + Math.sin(angle) * dist - 12,
      alpha: 0,
      scale: 0.2,
      duration: Phaser.Math.Between(480, 720),
      ease: "Cubic.easeOut",
      onComplete: () => dot.destroy(),
    });
  }

  const ring = scene.add
    .circle(worldX, anchorY - 36, 6, CRIT_TINT_GOLD, 0.35)
    .setDepth(PARTICLE_DEPTH - 1)
    .setScale(0.2);
  scene.tweens.add({
    targets: ring,
    scale: 4.5,
    alpha: 0,
    duration: 650,
    ease: "Cubic.easeOut",
    onComplete: () => ring.destroy(),
  });
}

export function pulseSpriteLevelUp(
  scene: Phaser.Scene,
  sprite: Phaser.GameObjects.Sprite,
): void {
  const baseX = sprite.scaleX;
  const baseY = sprite.scaleY;
  sprite.setTint(CRIT_TINT_GOLD);
  scene.tweens.add({
    targets: sprite,
    scaleX: baseX * 1.14,
    scaleY: baseY * 1.14,
    duration: 160,
    yoyo: true,
    ease: "Sine.easeOut",
    onComplete: () => {
      if (sprite.active) sprite.clearTint();
    },
  });
}
